import { Action } from "@ngrx/store";
import { ReduxAction } from "../redux.action";
import { UtilService } from "../../services";
import { TestOrderTestSelectionSession } from "../../models";

export class SetTestOrderTestSelectionSession implements ReduxAction {
  type: string = "SET_TEST_ORDER_TEST_SELECTION_SESSION";
  testSelectionSession: TestOrderTestSelectionSession;

  constructor(testSelectionSession: TestOrderTestSelectionSession) {
    this.testSelectionSession = testSelectionSession;
  }

  get() {
    return this.testSelectionSession;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/actions/test-order/set-test-order-test-selection-session.action.ts